export const recoveryPhraseWordCount = (value: string) =>
  value.trim().split(/\s+/).filter(Boolean).length;

export const isUsableRecoveryPhrase = (value: string) => recoveryPhraseWordCount(value) === 12;

export const recoveryErrorMessage = (cause: unknown) => {
  const message = cause instanceof Error ? cause.message : '';
  if (message === 'Recovery phrase is invalid') {
    return 'This isn’t a valid backup phrase. Check that all 12 words are spelled correctly and in the saved order.';
  }
  if (message === 'Recovery phrase could not unlock this repository') {
    return 'That backup phrase doesn’t match this trove. Check that you’re using the backup for this account and that the words are in the saved order.';
  }
  return message || 'Could not unlock this trove. Try again.';
};
